import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest, apiRequest2 } from '../_helpers/apiConfig';
import { toast } from 'react-toastify';


export const getAllCategorys = createAsyncThunk("category/getAllCategory", async (filters) => {
    const response = await apiRequest('POST', '/v1/category/getAllCategory', filters);
    return response;
});

export const refCounts = createAsyncThunk("admin/refCounts", async (filters) => {
    const response = await apiRequest('POST', '/v1/admin/refCounts', filters);
    return response;
});


export const deleteCategory = createAsyncThunk("category/deleteCategory", async (filters, { dispatch }) => {
    const response = await apiRequest('POST', '/v1/category/deleteCategory', filters);
    toast.info("Category deleted successfully.");
    dispatch(getAllCategorys())
    return response;
});




export const updateCategorys = createAsyncThunk("/category/updateCategory",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;

        const response = await apiRequest("POST", "v1/category/updateCategory", Payload);
        if (response.message) {
            toast.info("Category updated successfully.");
            thunkAPI.dispatch(getAllCategorys(forReferesh));
        }
        return response;
    }
);


export const createCategory = createAsyncThunk("/category/createCategory",
    async (arg, thunkAPI) => {
        const { Payload, forReferesh } = arg;
        const response = await apiRequest("POST", "v1/category/createCategory", Payload);
        if (response.message) {
            toast.info("Category created successfully.");
            thunkAPI.dispatch(getAllCategorys(forReferesh));
        }
        return response;
    }
);








const preferenceSlice = createSlice({
    name: 'preference',
    initialState: {
        preference: [],
        total: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCategorys.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllCategorys.fulfilled, (state, action) => {
                state.loading = false;
                state.preference = action?.payload?.data;
                state.total = action?.payload?.data;

            })
            .addCase(getAllCategorys.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })


            .addCase(deleteCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteCategory.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })




            .addCase(refCounts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(refCounts.fulfilled, (state, action) => {
                state.loading = false;
                state.refcount = action?.payload?.data;
                state.total = action?.payload?.data;

            })
            .addCase(refCounts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })






            .addCase(updateCategorys.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCategorys.fulfilled, (state, action) => {
                state.loading = false;
                state.preference = action?.payload;


            })
            .addCase(updateCategorys.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(createCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.preference = action?.payload;


            })
            .addCase(createCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })










    },
});

export default preferenceSlice.reducer;